module.exports = __webpack_public_path__ + "static/media/research.2551f1f2.png";